import { NotificationContext } from '@/components/Notifications/NotificationsProvider';
import { useContext } from 'react';

export const useNotifications = () => {
  const ctx = useContext(NotificationContext);

  if (!ctx) {
    throw new Error('useNotifications must be used inside NotificationProvider');
  }

  return ctx;
};
